import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { NameDto } from '@model/NameDto'
import { DemoTradingAccount, TradingAccount } from '@model/TradingAccount'

import { useDispatchOpenChat } from '@hooks/useDispatchOpenChat'

export type ChangeLeverageModalType = {
  visible: boolean
  previousValue?: NameDto
  newValue?: NameDto
  step: number
  data?: TradingAccount | DemoTradingAccount
  demo?: boolean
}

interface TradingAccountsChangeLeverageModalProps {
  data: ChangeLeverageModalType
  onProceed(): void
}

export const TradingAccountsChangeLeverageModal: BaseModalType<
  TradingAccountsChangeLeverageModalProps
> = (props) => {
  const { data, onProceed, close } = props

  const { t } = useTranslation()
  const { dispatchOpenChat, isLoading } = useDispatchOpenChat()

  const handleContactSupport = () => {
    dispatchOpenChat()
    close()
  }

  return (
    <Modal.FullScreen size='lg'>
      <Modal.Header>{t('Trading Account.Change Leverage')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Title>{`${data.previousValue?.name} > ${data.newValue?.name}`}</Modal.Body.Title>
        <Modal.Body.Text>
          <Modal.Body.Text color='text-warning-med-em'>
            {t('Trading Account.Warning')}{' '}
          </Modal.Body.Text>
          {t('Trading Account.Warning affect')}
        </Modal.Body.Text>
        <Modal.Body.Text>{t('Trading Account.Sufficient funds')}</Modal.Body.Text>
        <Modal.Body.Text>{t('Trading Account.Re login')}</Modal.Body.Text>
        <Modal.Body.Text>{t('Trading Account.Contact support')}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleContactSupport} loading={isLoading}>
          {t('Contact Support')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={onProceed}>{t('Change')}</Modal.Footer.Primary>
      </Modal.Footer>
    </Modal.FullScreen>
  )
}
